









import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Challenge from '../interfaces/challenge'
import Game from '../classes/game'

@Component
export default class ChallengeBox extends Vue {
  @Prop() private name!: string;
  @Prop() private game!: Game;
  @Prop() private navigator!: Record<string, string>;
  @Prop() private permanant!: Record<string, number>;
  @Prop() private challenges!: Challenge[];
  @Prop() private anyRunning!: boolean;
  @Prop() private challengeData!: Record<string, number>;

  get currentChallenge () {
    return this.challenges[this.challengeData.challengeNumber]
  }

  @Watch('game.stats.puzzlesSolved')
  puzzlesSolvedChanged () {
    if (this.challengeData.isActive && this.currentChallenge && this.isComplete) {
      this.exit()
      this.permanant.creditMultiplier *= this.currentChallenge.reward
      this.challengeData.challengeNumber++
      this.challengeData.solvedBefore = Infinity
    }
  }

  get isUnlocked () {
    if (!this.currentChallenge) {
      return false
    }
    return this.game.stats.puzzlesSolved >= this.currentChallenge.unlock
  }

  get isDisabled () {
    return !this.isUnlocked || this.challengeData.isActive || !this.currentChallenge || this.anyRunning
  }

  get puzzlesLeft () {
    if (!this.currentChallenge) {
      return Infinity
    }
    if (!this.challengeData.solvedBefore) {
      return Infinity
    }
    return this.currentChallenge.complete - (this.game.stats.puzzlesSolved - this.challengeData.solvedBefore)
  }

  get isComplete () {
    return this.puzzlesLeft <= 0
  }

  exit () {
    this.game.clearChallenge()
    this.challengeData.isActive = 0
  }

  runChallenge () {
    if (!this.currentChallenge) {
      return
    }
    this.challengeData.isActive = 1
    this.game.resetGame({
      noClicks: this.currentChallenge.noClicks || 0,
      destroyers: this.currentChallenge.destroyers || 0,
      noAutos: this.currentChallenge.noAuto || 0,
      rotate: this.currentChallenge.rotate || 0
    })
    this.navigator.location = 'sudoku'
    this.challengeData.solvedBefore = this.game.stats.puzzlesSolved
  }

  getText () {
    if (!this.currentChallenge) {
      return 'Challenege Complete'
    } else if (this.challengeData.isActive) {
      return `Solve ${this.puzzlesLeft} more puzzles to earn ${this.currentChallenge.reward} Credit Multiplier`
    }
    return `Solve ${this.currentChallenge.unlock} puzzles to Unlock`
  }
}
